import type { Patient } from "@louise/medical-history/basic-info/calculateBasicInfoCompletion";

// Treatment cycle types that indicate past fertility treatments
const TREATMENT_CYCLE_TYPES = [
  "ivf",
  "iui",
  "fet",
  "icsi",
  "oi",
  "egg_freezing",
  "embryo_freezing",
  "sperm_freezing",
];

type PatientCycleSummary = {
  status?: string | null;
  cycleType?: string | null;
};

type PatientWithPriorTreatmentAnswer = Patient & {
  fertilityHistory?: {
    hasPriorFertilityTreatments?: boolean | null;
  } | null;
};

export function calculateFertilityTreatmentsCompletion(
  patient: Patient | null | undefined,
) {
  // Get cycles from patient (same approach as FertilityTreatmentsContext)
  const cycles =
    (patient as (Patient & { cycles?: PatientCycleSummary[] }) | null)
      ?.cycles || [];

  // Filter for past treatments (closed cycles with a treatment type)
  const pastTreatments = cycles.filter(
    (c) =>
      c.status === "closed" &&
      !!c.cycleType &&
      TREATMENT_CYCLE_TYPES.includes(c.cycleType),
  );

  const hasPastTreatments = pastTreatments.length > 0;
  const hasPriorFertilityTreatments = (
    patient as PatientWithPriorTreatmentAnswer | null | undefined
  )?.fertilityHistory?.hasPriorFertilityTreatments;

  // Closed cycles or an explicit "no prior treatments" answer complete the section.
  // A "yes" answer without treatment details is partial until at least one cycle is saved.
  const completed =
    hasPastTreatments || hasPriorFertilityTreatments === false
      ? 2
      : hasPriorFertilityTreatments === true
        ? 1
        : 0;
  const label = `${completed}/2 answered`;

  const percent = completed / 2;
  return { percent, label, completed, total: 2 };
}
